function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.022 1.044A7.38 7.38 0 0114.95 7.57a7.38 7.38 0 01-7.377 7.38 7.377 7.377 0 01-6.523-3.93 7.379 7.379 0 0010.827-6.526c0-1.246-.31-2.42-.855-3.45z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.022 1.044l-.044.023a7.3 7.3 0 01.849 3.427 7.329 7.329 0 01-10.754 6.483.05.05 0 00-.067.067A7.426 7.426 0 007.573 15 7.429 7.429 0 0015 7.57 7.429 7.429 0 0011.045 1l-.023.044zm3.879 6.526a7.329 7.329 0 00-3.76-6.405 7.4 7.4 0 01.785 3.33A7.428 7.428 0 011.17 11.138 7.326 7.326 0 007.573 14.9a7.33 7.33 0 007.328-7.331z",
  fill: "currentColor"
})));